/**
 * FormUtils
 *
 * @type {{prepareDropdownOptions: (function(*, *, *): {title: *, value: *}[])}}
 */
const FormUtils = {
    /**
     *
     * @param items
     * @param valueKey
     * @param titleKey
     * @param translate
     * @returns {{title: *, value: *}[]}
     */
    buildDropdownOptions: (items, valueKey, titleKey, translate) => {
        return items.map(item => {
            return {
                value: item[valueKey],
                title: typeof translate !== 'undefined' && translate === true
                    ? window.$trans(item[titleKey])
                    : item[titleKey],
            };
        })
    },

    /**
     *
     * @param errors
     * @param key
     * @returns {{[p: string]: unknown}}
     */
    getErrors: (errors, key) => {
        const filtered = Object
            .keys(errors)
            .filter(errorKey => {
                return new RegExp(
                    key.replaceAll('.', '\\.').replaceAll('*', '(.*)')
                ).test(errorKey);
            });

        return Object
            .fromEntries(Object.entries(errors)
            .filter(([key, val]) => filtered.indexOf(key) > -1));
    },

    /**
     *
     * @param errors
     * @param key
     * @returns {{[p: string]: unknown}}
     */
    getErrorMessages: (errors, key) => {
        if (typeof errors !== 'object' || errors === null) {
            return [];
        }

        const filtered = Object
            .keys(errors)
            .filter(errorKey => {
                return new RegExp(
                    key.replaceAll('.', '\\.').replaceAll('*', '(.*)')
                ).test(errorKey);
            });

        let errorMessages = [];

        Object.entries(errors).forEach(([key, val]) => {
            if (filtered.indexOf(key) > -1) {
                errorMessages = errorMessages.concat(val);
            }
        })

        return errorMessages;
    },

    /**
     *
     * @param errors
     * @param key
     * @returns {boolean}
     */
    hasError(errors, key) {
        const errorMessage = this.getErrorMessages(errors, key);

        return !! errorMessage && errorMessage.length > 0;
    },

    /**
     *
     * @param errors
     * @param key
     * @returns {*|string}
     */
    getErrorMessage(errors, key) {
        const errorMessage = this.getErrorMessages(errors, key);

        if (! errorMessage) {
            return  '';
        }

        if (typeof errorMessage === 'string') {
            return errorMessage;
        }

        try {
            return errorMessage[0] ?? '';
        } catch (e) {
            return '';
        }
    }
};

export default FormUtils;
